import {
  ChevronRightIcon,
  ListItem,
  ListItemContent,
  UserGroupOutlineIcon,
} from '@mr-yum/frontend-ui'
import { useLogger } from 'hooks/useLogger'
import { RunningSocialTabGuestConfirmation } from 'lib/gql'
import { routes } from 'lib/routes'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'

interface Props {
  venueSlug: string
  tabId: string
  orderId?: string
  tab: RunningSocialTabGuestConfirmation
}

export const ShareTabCTA = ({ venueSlug, tab, tabId, orderId }: Props) => {
  const intl = useIntl()
  const { logEvent } = useLogger()

  const path = routes.socialTabJoin.toPath!({ venueSlug, tabId })
  const url = window.origin + path

  const handleShare = useCallback(
    async (e: React.MouseEvent) => {
      logEvent('Clicked on share tab CTA on tab confirmation', {
        tabId,
        orderId,
      })

      if (navigator.share) {
        e.preventDefault()
        void navigator.share({
          title: tab.tabName || '',
          url,
        })
      }
      // else just click through to SMS
    },
    [logEvent, tab.tabName, url, orderId, tabId],
  )

  return (
    <ListItem size="lg" asChild isInteractive>
      <a onClick={handleShare} href={`sms:;?&body=${encodeURIComponent(url)}`}>
        <ListItemContent
          label={intl.formatMessage({
            defaultMessage: 'Share your group order with friends',
            id: 'zVLaei',
          })}
          labelWeight="normal"
          size="lg"
          leftIcon={<UserGroupOutlineIcon />}
          rightIcon={<ChevronRightIcon />}
        />
      </a>
    </ListItem>
  )
}
